import { render, staticRenderFns } from "./zhanghaomimadl.vue?vue&type=template&id=5c71d9e6&scoped=true"
import script from "./zhanghaomimadl.vue?vue&type=script&lang=js"
export * from "./zhanghaomimadl.vue?vue&type=script&lang=js"
import style0 from "./zhanghaomimadl.vue?vue&type=style&index=0&id=5c71d9e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c71d9e6",
  null
  
)

export default component.exports